import { render } from "./ActionDisplayFreeModel.vue?vue&type=template&id=38f4c75f"
import script from "./ActionDisplayFreeModel.vue?vue&type=script&lang=ts"
export * from "./ActionDisplayFreeModel.vue?vue&type=script&lang=ts"
script.render = render

export default script